import type { DirectoryPartnerCard } from '../api/trusted-partners.api';
import { PartnerCard } from './PartnerCard';

/**
 * The responsive card grid shared by the page preview and the full list. The top padding and
 * the row gap leave room for each card's overhanging logo disc, which rises at most 32 px (FR-293).
 */
export function PartnerGrid({ partners }: { partners: DirectoryPartnerCard[] }) {
  return (
    <div className="grid gap-x-4 gap-y-12 pt-8 sm:grid-cols-2 lg:grid-cols-3">
      {partners.map((partner) => (
        <PartnerCard key={partner.entityId} partner={partner} />
      ))}
    </div>
  );
}
